<div class="admin">
  <div class="login row d-flex flex-column justify-content-center align-items-center">
    <div class="logo d-flex align-items-center justify-contet-between">
      <a>
        <img src="../../../assets/images/MC-white.svg" />
      </a>
      <div class="slogan">
        <span class="slogan-ar"> مركز الامتياز التجاري </span>
        <span class="slogan-en"> Franchise Center </span>
      </div>
    </div>

    <div class="col-md-4">
      <form class="form login-form" [formGroup]="form_Group" (ngSubmit)="send()">
        <div class="mb-4" *ngIf="errorMessage">
          <ngb-alert type="danger" (close)="errorMessage = null">
            {{ errorMessage }}
          </ngb-alert>
        </div>
        <p class="welcome text-center">إستعادة كلمة المرور</p>
        <p class="title text-center">ادخل بيانات حسابك، لإستعادة كلمة المرور</p>
        <p *ngIf="isMailSent" class="text-center" style="color: black;font-size: 20px;">
          {{"ForgotPassword.Success" |translate}}
        </p>

        <div *ngIf="!isMailSent">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{"ForgotPassword.Email" | translate}}
            </label>
            <input [qcId]="'user-email'" type="text" class="form-control" formControlName="email"
              placeholder="{{'ForgotPassword.Email_P' | translate }}" />

            <div class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'email', form_Group)">
                {{"ForgotPassword.Email_Required" | translate}}
              </div>
              <div *ngIf="controlHasError('pattern', 'email', form_Group)">
                {{"ForgotPassword.Email_String" | translate}}
              </div>
              <div
                *ngIf="controlHasError('minlength', 'email', form_Group) || controlHasError('maxlength', 'email', form_Group)">
                {{"ForgotPassword.Email_Length" | translate}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="captchaInput">{{"ForgotPassword.CaptchaInput" | translate}}</label>
            <input type="text" maxlength="4" id="captchaInput" class="form-control" formControlName="captchaInput"
              placeholder="{{'ForgotPassword.CaptchaInput_P' | translate }}" />
            <div class="input-img" (click)="refreshCaptcha()">
              <img *ngIf="captchaImageUrl" [src]="captchaImageUrl | safeResourceUrl" title="اضغط لتغيير الرمز"
                alt="Captcha Image" />
            </div>
            <div class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'captchaInput', form_Group)">
                {{"ForgotPassword.CaptchaInput_Required" | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="login-button">
          <button type="submit" class="btn DS btn-green btn-block" *ngIf="!isMailSent">إرسال</button>
          <a class="btn DS btn-green btn-block mt-2 hyperLink d-flex align-items-center justify-content-center" routerLink="/adminlogin" style="white-space: nowrap;">
            الرجوع الي تسجيل الدخول 
            <span class="fas fa-arrow-left fa-sm iconSpan"></span>
          </a>
        </div>
      </form>
    </div>
  </div>
</div>